import { styled } from '@linaria/react';
import { colors, fonts, layout } from '../../theme/tokens';
import type { PriceSize } from './PriceDisplay.types';

const fontSizeFor = (size: PriceSize) =>
  size === 'xlarge'
    ? fonts.size['2xl']
    : size === 'large'
    ? fonts.size.xl
    : size === 'medium'
    ? fonts.size.lg
    : size === 'base'
    ? fonts.size.base
    : fonts.size.sm;

const desktopFontSizeFor = (size: PriceSize) =>
  size === 'xlarge' ? fonts.size['3xl'] : fontSizeFor(size);

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, min-content);
  gap: 3px;
  align-items: center;
`;

export const PriceLabel = styled.span<{
  $size: PriceSize;
}>`
  font-family: ${fonts.body};
  font-size: ${(p) => fontSizeFor(p.$size)};
  color: ${colors.fontSecondary};

  @media (min-width: ${layout.desktopBreakpoint}) {
    font-size: ${(p) => desktopFontSizeFor(p.$size)};
  }
`;

export const PriceAmount = styled.span<{
  $size: PriceSize;
  $weight?: 'normal' | 'medium' | 'bold';
}>`
  font-family: ${fonts.body};
  font-weight: ${(p) =>
    p.$weight === 'medium'
      ? fonts.weight.medium
      : p.$weight === 'normal'
      ? fonts.weight.normal
      : fonts.weight.bold};
  color: ${colors.fontPrimary};
  font-size: ${(p) => fontSizeFor(p.$size)};

  @media (min-width: ${layout.desktopBreakpoint}) {
    font-size: ${(p) => desktopFontSizeFor(p.$size)};
  }
`;

export const DiscountRow = styled.span`
  display: inline-flex;
  align-items: baseline;
  gap: 0.4rem;
`;

export const OriginalPrice = styled.span<{
  $size: PriceSize;
}>`
  font-family: ${fonts.body};
  font-weight: ${fonts.weight.normal};
  color: ${colors.grey};
  text-decoration: line-through;
  font-size: ${(p) => fontSizeFor(p.$size)};

  @media (min-width: ${layout.desktopBreakpoint}) {
    font-size: ${(p) => desktopFontSizeFor(p.$size)};
  }
`;

export const DiscountedPrice = styled.span<{
  $size: PriceSize;
}>`
  font-family: ${fonts.body};
  font-weight: ${fonts.weight.bold};
  color: ${colors.fontPrimary};
  font-size: ${(p) => fontSizeFor(p.$size)};

  @media (min-width: ${layout.desktopBreakpoint}) {
    font-size: ${(p) => desktopFontSizeFor(p.$size)};
  }
`;
